import AuthAPI from "./auth.js";
const Auth = new AuthAPI();

// Public
export function completeDocument(notarizationId, documentId, data) {
	return Auth.POST(`/notarization/${notarizationId}/documents/${documentId}/Complete`, data);
}

export function declineDocument(notarizationId, documentId) {
	return Auth.POST(`/notarization/${notarizationId}/documents/${documentId}/Decline`);
}

export function appendNotarialAct(notarizationId, documentId, data) {
	return Auth.POST(`/notarization/${notarizationId}/documents/${documentId}/AppendNotarialAct`, data);
}

export function removeNotarialAct(notarizationId, documentId, notarialActId) {
	return Auth.POST(`/notarization/${notarizationId}/documents/${documentId}/RemoveNotarialAct/${notarialActId}`);
}

export function notarialActs(notarizationId, documentId) {
	return Auth.GET(`/notarization/${notarizationId}/documents/${documentId}/NotarialActs`);
}

export function refreshExistingDocument(notarizationId, documentId) {
	return Auth.POST(`/notarization/${notarizationId}/documents/${documentId}/Refresh`);
}